import resetErrors from '../action/reset-errors'

export default () => {
  return async (dispatch) => {
    dispatch(resetErrors())
  }
}
